import React from 'react';
import { Typography, Space } from 'antd';
import { PictureOutlined } from '@ant-design/icons';
import { Field, FileInput } from '@guuru/react-forms';

const { Text } = Typography;

const Moments = function ({ loading }: { loading: boolean }) {
  return (
    <Field
      shouldUpdate
      label={(
        <Space>
          <PictureOutlined />
          <Text>Moments</Text>
        </Space>
      )}
      name="moments"
      tooltip="Select up to 3 moments to showcase in your community profile"
      extra={(
        <Text italic type="secondary" style={{ lineHeight: 2 }}>
          Enrich your profile showing your passion and brand love.
        </Text>
    )}
    >
      <FileInput keepAspect editable maxCount={3} disabled={loading} />
    </Field>
  );
};

export default Moments;
